/**
 * EPN-104 — the one, shared wording for the "shadow" payroll-calculation warning. This is the exact text
 * the Custom Pay Run backend already returns as `shadowCalculationWarning` on its preview
 * (`CustomPayRunService.cs`), previously hard-coded separately in Custom Pay Run's Calculate step. Module 6's
 * tax provider is still mock-only and not approved for live payroll, so every screen that shows
 * calculated payroll figures to a reviewer carries this same warning. Do not reword it here without a
 * compliance decision — it must stay identical to the backend string.
 */
export const SHADOW_CALCULATION_WARNING = 'SHADOW CALCULATION — NOT APPROVED FOR PRODUCTION PAYROLL';
